import { render, staticRenderFns } from "./valmistumispyynnot.vue?vue&type=template&id=7c264819&"
import script from "./valmistumispyynnot.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports